import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetTenantStripeConnectQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTenantStripeConnectQuery = { __typename?: 'Query', tenantStripeConnect: { __typename?: 'TenantStripeConnectData', connectedAccountId?: string | null, onboardingComplete: boolean, taxSettingsStatus: Types.StripeTaxSettingsStatus, taxMissingFields: Array<string>, taxReadinessCheckedAt?: Types.TDateISO | null, isTaxReady: boolean, activeTaxRegistrationCount: number, country?: string | null } };

export type TenantStripeConnectSummaryFragment = { __typename?: 'TenantStripeConnectData', connectedAccountId?: string | null, onboardingComplete: boolean, taxSettingsStatus: Types.StripeTaxSettingsStatus, taxMissingFields: Array<string>, taxReadinessCheckedAt?: Types.TDateISO | null, isTaxReady: boolean, activeTaxRegistrationCount: number, country?: string | null };

export const TenantStripeConnectSummaryFragmentDoc = new TypedDocumentString(`
    fragment TenantStripeConnectSummary on TenantStripeConnectData {
  connectedAccountId
  onboardingComplete
  taxSettingsStatus
  taxMissingFields
  taxReadinessCheckedAt
  isTaxReady
  activeTaxRegistrationCount
  country
}
    `, {"fragmentName":"TenantStripeConnectSummary"});
export const GetTenantStripeConnectDocument = new TypedDocumentString(`
    query GetTenantStripeConnect {
  tenantStripeConnect {
    ...TenantStripeConnectSummary
  }
}
    fragment TenantStripeConnectSummary on TenantStripeConnectData {
  connectedAccountId
  onboardingComplete
  taxSettingsStatus
  taxMissingFields
  taxReadinessCheckedAt
  isTaxReady
  activeTaxRegistrationCount
  country
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetTenantStripeConnect: build.query<GetTenantStripeConnectQuery, GetTenantStripeConnectQueryVariables | void>({
      query: (variables) => ({ document: GetTenantStripeConnectDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetTenantStripeConnectQuery, useLazyGetTenantStripeConnectQuery } = injectedRtkApi;
